module.exports = __webpack_public_path__ + "static/media/zillow.251a4516.svg";